var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrandLogoBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0284356 1.55273L19.7107 7.58763L16.2691 8.64088L0.0284356 3.65924V5.76576L12.8276 9.69415L9.38604 10.7474L0 7.87229V9.97881L5.94448 11.8007L0 13.6225V15.729L23.1238 8.64088V7.67302C23.1238 6.98983 22.6687 6.39203 22.0145 6.19276L1.99098 0.0724638C1.02393 -0.240668 0.0284356 0.499465 0.0284356 1.55273Z",
    fill: "#0058FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0224609 19.9137L23.1462 12.8255V10.719L0.0224609 17.8071V19.9137Z",
    fill: "#0058FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.02418 23.5004L22.0477 17.3801C22.7019 17.1808 23.157 16.583 23.157 15.8998V14.9604L0.0332031 22.0486C0.0332031 23.0449 1.02869 23.8135 2.02418 23.5004Z",
    fill: "#0058FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogoBlue);
export default __webpack_public_path__ + "static/media/brand-logo-blue.375a598a53bf590ee71206b19ca30458.svg";
export { ForwardRef as ReactComponent };